import React from "react"
import styled from "styled-components"
import { OrganizationCultureGrid } from "../OrganizationCultureGrid"
import { IOrganizationCard } from "../../molecules/OrganizationCard"
import { AosWrapper } from "../../molecules/AosWrapper"
import { Headline, StyledGradientTitle } from "../../../utils"

const Wrapper = styled.div`
  padding: 80px 20px;
  background-color: ${(props) => props.theme.softwareSelectionColor};
  @media (max-width: 1023px) {
    padding: 50px 60px;
  }
  @media (max-width: 600px) {
    padding: 40px 20px;
  }
`

const HeadlineText = styled(Headline)`
  margin-bottom: 40px;
  @media (max-width: 1023px) {
    margin-bottom: 20px;
  }
`

const CultureList: Array<IOrganizationCard> = [
  {
    title: "Remote Team Management",
    icon: <img src={"/assets/icons/remote-team.svg"} />,
    lightIcon: <img src={"/assets/icons/remote-team-light.svg"} />,
    content: `RTW is an established tech company with 50+\nemployees working remotely in parallel\n making remote working effective and more\n productive.`,
  },
  {
    title: "Career Growth Opportunities",
    icon: <img src={"/assets/icons/growth.svg"} />,
    lightIcon: <img src={"/assets/icons/growth-light.svg"} />,
    content:
      "We care for our RTW family and their growth\n so we have got them covered with full-proof\n path to bloom. We build positive work culture\n to increase job satisfaction.",
  },
  {
    title: "Opportunities for Initiatives",
    icon: <img src={"/assets/icons/idea.svg"} />,
    lightIcon: <img src={"/assets/icons/idea-light.svg"} />,
    content:
      "RTW offers freedom to take initiatives\n creating a culture of innovation and creativity.\n We also encourage self development through\n articles writing.",
  },
  {
    title: "In tune with Latest Tech",
    icon: <img src={"/assets/icons/jet-rocket-science.svg"} />,
    lightIcon: <img src={"/assets/icons/jet-rocket-science-light.svg"} />,
    content:
      "RTW attempts to become up-to-date with the\n most recent advancement & trends in\n technology. We equip employee with the\n skills needed to use latest technologies.",
  },
  {
    title: "Reward & Recognition",
    icon: <img src={"/assets/icons/reward.svg"} />,
    lightIcon: <img src={"/assets/icons/reward-light.svg"} />,
    content:
      "We understand and appreciate efforts made\n by our employees everyday and  make sure\n that our employees are motivated, satisfied\n and feel valued.",
  },
  {
    title: "Entertainment",
    icon: <img src={"/assets/icons/bounce.svg"} />,
    lightIcon: <img src={"/assets/icons/bounce-light.svg"} />,
    content:
      "We organize regular meet-ups and team-\n building games focusing on the stronger and\n healthier bond between colleagues .\nWhat else could be better than this.",
  },
]

const OrganizationCultureSection = () => {
  return (
    <Wrapper id={"culture"}>
      <AosWrapper>
        <HeadlineText>
          {"Sneak-peak to our Organization"}
          <StyledGradientTitle>{" Culture"}</StyledGradientTitle>
        </HeadlineText>
        <OrganizationCultureGrid items={CultureList} />
      </AosWrapper>
    </Wrapper>
  )
}

export { OrganizationCultureSection }
